export default "__VITE_ASSET__CmynQsnD__"